import api_config from '../config/api'

export default {
	getContact() {
		return api_config.get('api/contact/1')
	},
}
